import { Controller } from 'stimulus'
export default class extends Controller {
  static targets = ['savedPaymentRadiosContainer', 'paymentMethodLabel']
  static values = {
    stayExpanded: Boolean,
  }

  connect() {
    this.nextStepNoticeContainer = document.querySelector(
      '.js-checkout-next-step-notice'
    )
  }

  toggleInputs() {
    this.savedPaymentRadiosContainerTarget.classList.toggle('hidden')
  }

  changeSubmitLabelToOnsite() {
    this.nextStepNoticeContainer.classList.add('hidden')
    const btn = this.getSubmitButton()
    btn.innerHTML = btn.dataset.onsiteLabel
  }

  changeSubmitLabelToOffsite(e) {
    this.nextStepNoticeContainer.classList.remove('hidden')
    this.nextStepNoticeContainer.innerHTML = e.params.nextStepNotice
    const btn = this.getSubmitButton()
    btn.innerHTML = btn.dataset.offsiteLabel
  }

  // Swap the label of the selected saved payment method (e.g. a credit card) in the dropdown of saved payment method
  swapSelectedMethod(e) {
    const label = e.currentTarget.nextSibling
    if (label) {
      this.paymentMethodLabelTargets[0].innerHTML = label.innerHTML

      if (!this.stayExpandedValue) {
        this.savedPaymentRadiosContainerTarget.classList.add('hidden')
      }
    }
  }

  submitForm() {
    this.element.closest('form').submit()
  }

  getSubmitButton() {
    return this.element.closest('form').querySelector('.submit-payment')
  }
}
